import { ASSETS_FOLDER, SOUND_ATMO } from '../constants';
import { getMousePositionY } from './Mover';

const ATMO_FADE = 1000;

let sndManager = null;
let atmoTop = null;
let atmoBtm = null;

let atmoMuted = true;
let atmoOff = true; // to disable update during fade + off state
let muteDelay = null;
let fadeDelay = null; // to disable volume update during in-fade
let updateEnabled = false; // to disable move volume update during page init (introduced slight crackling sound)

// -------------------------------------------------------
// Init
// -------------------------------------------------------

export const init = () => {
  if (sndManager === null) {
    const { DeSnd } = window;
    sndManager = new DeSnd.SoundManager();
    sndManager.fadeDuration = ATMO_FADE;

    // start atmo
    atmoTop = sndManager.addSound('atmo-top', `${ASSETS_FOLDER}snd/atmo-top`);
    atmoTop.loop = true;
    atmoTop.inFade = true;
    atmoTop.outFade = true;

    atmoBtm = sndManager.addSound('atmo-btm', `${ASSETS_FOLDER}snd/atmo-btm`);
    atmoBtm.loop = true;
    atmoBtm.inFade = true;
    atmoBtm.outFade = true;

    // enable update
    setTimeout(() => {
      updateEnabled = true;
    }, 3000);
  }
};

// -------------------------------------------------------
// Main controls
// -------------------------------------------------------

export const muteSwitch = () => {
  sndManager.mute = !sndManager.mute;
  return sndManager.mute;
};

export const soundBlockState = () =>
  sndManager && sndManager.context && sndManager.context.state === 'suspended';

// -------------------------------------------------------
// Atmo update
// -------------------------------------------------------

const HALF_LIMIT = SOUND_ATMO.CENTER - SOUND_ATMO.LIMIT;

export const atmoUpdate = () => {
  // update only if playing
  if (updateEnabled && !atmoOff) {
    const mY = getMousePositionY();

    // calc volume
    const limitTop = Math.max(
      Math.min(1 - (mY - SOUND_ATMO.CENTER) / HALF_LIMIT, 1),
      0
    );
    const limitBtm = Math.max(
      Math.min((mY - SOUND_ATMO.LIMIT) / HALF_LIMIT, 1),
      0
    );

    // set volume
    atmoTop.volume = limitTop;
    atmoBtm.volume = limitBtm;
  }
};

// -------------------------------------------------------
// Mute
// -------------------------------------------------------

const callMute = doMute => {
  muteDelay = setTimeout(() => {
    if (doMute && !atmoMuted) {
      atmoMuted = true;
      atmoOff = true;
      atmoTop.pause();
      atmoBtm.pause();
    } else if (!doMute && atmoMuted) {
      atmoMuted = false;
      atmoTop.play();
      atmoBtm.play();
      // fade delay
      fadeDelay = setTimeout(() => {
        atmoOff = false;
      }, ATMO_FADE * 2);
    }
  }, 500);
};

export const muteAtmo = doMute => {
  clearTimeout(muteDelay);
  clearTimeout(fadeDelay);
  callMute(doMute);
  return soundBlockState(); // note - not ideal but sufficient as chrome 66 hotfix
};



// WEBPACK FOOTER //
// ./src/utils/SoundManager.js